module.exports = __webpack_public_path__ + "img/img75.e4141d1d.svg";